import React from "react";
import { PickList, PickListChangeEvent } from "primereact/picklist";

interface PickListSchemProps<T = any> {
  source: T[];
  target: T[];
  itemTemplatePanel: (item: T) => React.ReactNode;
  sourceHeader?: string;
  targetHeader?: string;
  filterby?: string;
  datakeystr?: string;
  onChange?: (source: T[], target: T[]) => void;
  mainHeader?: string;
  disabled: boolean;
}

const PickListSchem = <T,>({
  source,
  target,
  itemTemplatePanel,
  sourceHeader = "Available List",
  targetHeader = "Selected List",
  filterby,
  datakeystr = "",
  onChange,
  mainHeader,
  disabled,
}: PickListSchemProps<T>) => {
  return (
    <div className="WholePicklistPanel">
      <h6>{mainHeader}</h6>

      <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
        <div className="PickListPanel">
          <PickList
            dataKey={datakeystr}
            source={source}
            target={target}
            onChange={(e: PickListChangeEvent) => {
              if (disabled) return;
              onChange?.(e.source as T[], e.target as T[]);
            }}
            className={disabled ? "picklist-disabled" : ""}
            itemTemplate={itemTemplatePanel}
            filter
            filterBy={filterby}
            breakpoint="768px"
            sourceHeader={sourceHeader}
            targetHeader={targetHeader}
            sourceStyle={{ height: "16rem" }}
            targetStyle={{ height: "16rem" }}
            sourceFilterPlaceholder="Search by name"
            targetFilterPlaceholder="Search by name"
            // showSourceControls={showSourceControls}
            // showTargetControls={showTargetControls}
            // disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default PickListSchem;
